import React from 'react'
import s from './PanelBase.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'

const ReadOnlyBranchesList = ({
  base,
  baseType = 'базы',
  branches = [],
  branchesFilter = '',
  setBranchesFilter = () => {},
  loadBranchesPage = () => {},
  branchesPagination = {},
}) => {
  const filtered = branches.filter(b => {
    const q = (branchesFilter || '').toLowerCase()
    if (!q) return true
    return (b.name && b.name.toLowerCase().includes(q)) || (b.address && b.address.toLowerCase().includes(q))
  })

  return (
    <div className={s.subPanel}>
      <div className={s.subPanelTitle}>Филиалы этой {baseType}</div>

      <div className={s.searchRow}>
        <input
          className={s.searchInput}
          placeholder="Поиск по филиалу..."
          value={branchesFilter || ''}
          onChange={(e) => setBranchesFilter(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') loadBranchesPage(base.id, 1, branchesFilter || '') }}
        />
      </div>

      {filtered.length ? (
        <>
          <div className={s.tableWrap}>
            <div className={s.tableScroll}>
            <table className={s.table}>
              <thead>
                <tr>
                  <th>№</th>
                  <th>Название</th>
                  <th>Адрес</th>
                  <th>Местоположение</th>
                  <th>Создано</th>
                  <th>Статус</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((b, index) => (
                  <tr key={b.id}>
                    <td className={s.numCell}>{index + 1}</td>
                    <td style={{ fontWeight: 600, color: '#1e293b' }}>{b.name || '—'}</td>
                    <td style={{ color: '#64748b' }}>{b.address || '—'}</td>
                    <td>
                      {b.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${b.geo}`, '_blank')} className={s.geoBtn}>🗺️ Карты</button>
                            <button onClick={() => { const el = document.getElementById(`branch-map-${b.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none' }} className={s.mapToggleBtn}>📌</button>
                          </div>
                          <div id={`branch-map-${b.id}`} style={{ width: 200, height: 150, display: 'none' }}>
                            <MiniMap geo={b.geo} />
                          </div>
                        </div>
                      ) : '—'}
                    </td>
                    <td style={{ fontSize: 12, color: '#64748b' }}>{b.created_at}</td>
                    <td>
                      <span className={`${s.badge} ${b.is_active ? s.active : s.inactive}`}>
                        {b.is_active ? 'Активен' : 'Неактивен'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </div>
          </div>

          {!branchesFilter && branchesPagination?.count > 0 && (
            <div className={s.pagination}>
              <button className={s.pageBtn} disabled={!branchesPagination.previous} onClick={() => loadBranchesPage(base.id, (branchesPagination.page || 1) - 1)}>Пред.</button>
              <span>Стр. {branchesPagination.page || 1} из {Math.ceil(branchesPagination.count / 25)}</span>
              <button className={s.pageBtn} disabled={!branchesPagination.next} onClick={() => loadBranchesPage(base.id, (branchesPagination.page || 1) + 1)}>След.</button>
            </div>
          )}
        </>
      ) : (
        <div className={s.empty}>Филиалы не найдены</div>
      )}
    </div>
  )
}

export default ReadOnlyBranchesList
